import React, { useState } from 'react';

import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import {
  ResetProjectMilestonesModal,
  SaveMilestoneModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';

import {
  Button,
  useTheme
} from '@mui/material';
import { useParams } from 'react-router-dom';


export type MilestonesHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MilestonesHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Project Milestones'
      subtitle='List of all Milestones'
      searchBar={<></>}
      actionButtons={(
        <ActionButtonsGroup />
      )}
    />

  );
};

type ActionButtonsGroupProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isResetVisible,
    setIsResetVisible
  ] = useState(false);

  const access = useAccessState('Milestone');
  const params = useParams();

  return (
    <>
      {isVisible && (
        <SaveMilestoneModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id=''
        />
      )}
      {isResetVisible && (
        <ResetProjectMilestonesModal.FC
          isVisible={isResetVisible}
          handleClose={() => setIsResetVisible(() => false)}
          id={params.projectId ?? ''}
        />
      )}
      <Button
        variant='contained'
        color='primary'
        disabled={!access.create}
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create Milestone
      </Button>
      <Button
        variant='contained'
        color='warning'
        disabled={!access.update}
        onClick={() => setIsResetVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='EDIT'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Reset Project Milestones
      </Button>

    </>
  );
};

